import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type ResponseValue = "fulfilled" | "rejected" | "pending" | ""; 

export interface TableManagement {
    editMode: boolean;
    createMode: boolean;
    processingRequest: boolean;
    responseValue: ResponseValue;
    responseMessage: string | null;
}

const initialState: TableManagement = {
    editMode: false,
    createMode: false,
    processingRequest: false,
    responseValue: "",
    responseMessage: "",
};

export const tableManagementReducer = createSlice({
    name: "tableManagement",
    initialState,
    reducers: {
        setEditMode: (state, action: PayloadAction<boolean>) => {
            state.editMode = action.payload;
        },
        setCreateMode: (state, action: PayloadAction<boolean>) => {
            state.createMode = action.payload;
        },
        setProcessingRequest: (state, action: PayloadAction<boolean>) => {
            state.processingRequest = action.payload;
        },
        setResponseValue: (state, action: PayloadAction<ResponseValue>) => {
            state.responseValue = action.payload;
        },
        setResponseMessage: (state, action: PayloadAction<string>) => {
            state.responseMessage = action.payload;
        },
        resetResponseMessage: (state) => {
            state.responseMessage = null;
        },
    }
})

export const {
    setEditMode,
    setCreateMode,
    setProcessingRequest,
    setResponseValue,
    setResponseMessage,
    resetResponseMessage
} = tableManagementReducer.actions;

export default tableManagementReducer.reducer;